import { t } from '../../app/i18n';

export default {
  PAYMENT_WAITING: 'PAYMENT_WAITING',
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  RECEIVED: 'RECEIVED',
  REFUNDED: 'REFUNDED',
  //ASSIGNED_TO_INSTALLMENT: 'ASSIGNED_TO_INSTALLMENT',
  ASSIGNED_TO_LOAN: 'ASSIGNED_TO_LOAN',
  ASSIGNED_TO_ACCOUNT: 'ASSIGNED_TO_ACCOUNT',
  RETURN_OVERPAY: 'RETURN_OVERPAY',
  TRUSTPAY: 'TRUSTPAY'
};

export const translation = {
  PAYMENT_WAITING: t('Na spracovanie'),
  PENDING: t('Čaká sa na potvrdenie z banky'),
  PAID: t('Odoslaná'),
  FAILED: t('Zlyhaná platba'),
  RECEIVED: t('Nenapárovaná'),
  REFUNDED: t('Refundácia'),
  //ASSIGNED_TO_INSTALLMENT: t('Napárovaná na splátku'),
  ASSIGNED_TO_LOAN: t('Splátka istiny'),
  ASSIGNED_TO_ACCOUNT: t('Napárovaná na investora'),
  RETURN_OVERPAY: t('Vrátenie preplatku'),
  TRUSTPAY: t('Platby od TrustPay')
};



// WEBPACK FOOTER //
// ./src/common/enums/paymentStatus.js